"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApDropdown = void 0;
var React = require("react");
var styles_1 = require("./styles");
exports.ApDropdown = function (_a) {
    var trigger = _a.trigger, alignment = _a.alignment, behaviour = _a.behaviour, children = _a.children, className = _a.className;
    var triggerWithClassName = React.cloneElement(trigger(), {
        className: (trigger().props.className ? trigger().props.className : '') + " ap-dropdown-trigger"
    });
    return (React.createElement(styles_1.StyledDropdown, { behaviour: behaviour, className: "ap-dropdown " + (className ? className : '') },
        React.createElement(React.Fragment, null, triggerWithClassName),
        React.createElement(styles_1.StyledMenu, { tabIndex: 0, alignment: alignment, behaviour: behaviour }, children)));
};
exports.ApDropdown.defaultProps = {
    alignment: 'left',
    behaviour: 'click'
};
//# sourceMappingURL=ApDropdown.js.map